import PubSub from "underpub-js";

var AvailabilityTabs = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-AvailabilityTabs',
	};

	$.extend(true, this.options, options);

};

AvailabilityTabs.prototype.init = function() {

	var self = this;

};

export default AvailabilityTabs;
